import { LOCALES } from "../locales";

export default {
  [LOCALES.ENGLISH]: {
    //Home
    //Nav
    home: "HOME",
    referral: "REFERRAL",
    api: "APIs",
    faqs: "FAQs",
    language: "Language",
    profile: "Profile",
    changePassword: "Change Password",
    signup: "SIGN UP",
    contactUs : "CONTACT US",
    login: "LOGIN",
    logout: "Logout",

    //Banner 0
    ETIQAAFFILIATES: "ETIQA APIs",
    "banner-subtitle": "For partners & developers",
    "banner-subtitle2":
      "Integrate insurance solutions to any app or website easily",

    //Content 5
    "content5-title": "APIs",
    "content5-sub-title":
      "Welcome to Etiqa API Portal. Etiqa API portal provides API service to make it simple to sell and offer our products via your website or mobile app.",

    //Feature 8
    "feature8-title": "How it Works?",
    "feature8-item-title1": "1) SIGN UP/ LOGIN",
    "feature8-item-sub-title1":
      "Sign up and login to browse the full list of our APIs.",
    "feature8-item-title2": "2) CHOOSE APIS",
    "feature8-item-sub-title2":
      "Choose the different options for integration, with various levels of customisation.",
    "feature8-item-title3": "3) INTEGRATE SERVICE",
    "feature8-item-sub-title3":
      "Integrate the product with your website or application and GO LIVE.",

    //Banner 5
    "banner5-title": "Need Help?",
    "banner5-sub-title": "FAQs",
    "banner5-item1": "1) About Etiqa API Portal",
    "banner5-item2": "2) How to access API?",
    "banner5-item3": "3) What is API?",
    "banner5-item4": "4) What is JWT WEB TOKEN?",
    "banner5-button": "More",

    //REFERRAL
    "Referral-catalog": "Referral Catalog",
    "Referral-content":
      "Sign up now to retrieve your unique referral link and start sharing!",
    "Referral-sub-title": "How our Refferal Program works",
    "Referral-item-title1": "Sign-up and refer",
    "Referral-item-sub-title1":
      'Sign-up and retrieve your unique referral link under "Referral Catalog"',
    "Referral-item-title2": "Share easily",
    "Referral-item-sub-title2": "Easily share on your favourite social media",
    "Referral-item-title3": "Get rewarded",
    "Referral-item-sub-title3":
      "Redeem your reward for every successful referral purchase",
    half_term1: "* Do refer to our ",
    half_term2: "Referral Terms and conditions ",
    half_term3: "for more details",
    "Referral-nav1": "All",
    "Referral-nav2": "VEHICLE",
    "Referral-nav3": "PA",
    "Referral-nav4": "FIRE",
    "Referral-nav5": "BOND",
    "Referral-nav6": "LIFE",
    "Referral-nav7": "OTHER",
    "Referral-question-title": "Still have questions about Etiqa Referral?",
    "Referral-question1":
      "Do I have to be an existing Etiqa customer to start referring?",
    "Referral-answer1":
      "Not immediately. You can start referring even before you’re an Etiqa customer. You can redeem your referral rewards later after you have made your Etiqa purchase.",
    "Referral-question2": "How many people can I refer?",
    "Referral-answer2": "There are no limits.",
    "Referral-question3": "How long will it take to get paid?",
    "Referral-answer3":
      "Your referral rewards will be credited into your Etiqa eWallet 60 days after the policy commences. If you haven’t bought your policy, you will then receive your referral rewards 60 days after your policy commences.",
    "Referral-question4": "How will I get paid?",
    "Referral-answer4":
      "The referral rewards will be credit into your Etiqa eWallet, which you can then option to encash or use it for future Etiqa purchase.",
    "Referral-question5": "How can I encash the referral reward?",
    "Referral-answer5":
      "You may login to TiqConnect to set up a Direct Credit Bank Transfer or use PayNow to encash your credits in your eWallet to your Singapore Bank Account.",

    //API

    //FAQs
    "faq-title": "FAQs",
    "sub-faq-title": "Need Help?",
    "panel-header1": "About Etiqa API Portal",
    "panel-content1":
      "Interested to provide our insurance solutions to your users? Partners can do so by leveraging on our APIs, widgets or marketing assets.",
    "panel-header2": "What is API ?",
    "panel-content2":
      " In basic terms, API (Application Programming Interface) is an interface of an application, which allows other applications to communicate with it. Get access to real time data and services on Etiqa API Portal. To view available functionalities, do check out our ",
    "panel-header3": "How to access API?",
    "panel-content3":
      " Sign up and create your free Developer Account to gain instant access to Etiqa’s sandbox environment. Breeze through our portal with a Get Started documentation upon successful login.",
    "panel-header4": "What is JWT WEB TOKEN?",
    "panel-content4":
      "JSON Web Token (JWT, RFC 7519) is a way to encode claims in a JSON document that is then signed.JWTs can be used as OAuth 2.0 Bearer Tokens to encode all relevant parts of an access token into the access token itself instead of having to store them in a database.",
  },
};
